'use client';

import React from 'react';
import { Shield } from 'lucide-react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function PrivacyPolicyContent() {
  return (
    <LegalDocumentBody
      pageId="privacy"
      icon={<Shield size={13} className="text-primary" />}
      footerLinks={[
        { href: '/terms-of-service', labelKey: 'termsLink' },
        { href: '/about', labelKey: 'aboutLink' },
      ]}
    />
  );
}
